import { EntityTypes } from "../../EntityTypes";
import { IMediaSecuredResource } from "../../media";
import { ILearnerLink } from "../../topics";
import { ITimestampable, IHydraResource, Embed } from "../../types";
import { IUserResource } from "../../users";
export interface IGroupWorkResource extends IHydraResource, ITimestampable {
    "@type": EntityTypes.GROUP_WORK;
    groupSpace: string;
    comment: string;
    learner: IUserResource;
    links: ILearnerLink[];
    mediaSecured: Embed<IMediaSecuredResource, "title" | "url" | "size">[];
    /** Public recipients of corrections on this submission; their feedback remains private. */
    correctedLearners?: IUserResource[];
    /** Who evaluated this submission last and when; the comment and verdicts stay with their recipients. */
    latestEvaluation?: {
        trainer: Pick<IUserResource, "name" | "surname">;
        evaluatedAt: string;
    };
}

export const isGroupWorkResource = (resource: any): resource is IGroupWorkResource => {
    return resource["@type"] === EntityTypes.GROUP_WORK;
};
